<template>
    <section>
       <div class="story" :v-bind="theme" :id="anchorId">
            <div class="story-content">
                <div class="story-text" v-bind:class="orderTextElement">
                    <div class="info">
                        <h1 v-if="header !== undefined" class="story-header">{{header}}</h1>
                        <div :class="{slot:!showAll && readMore}" @click="toggleShowAll">
                            <slot/>
                            <p v-if="!showAll && readMore" :style="{textAlign: 'center', display: 'block'}">Read More</p>
                        </div>
                    </div>
                </div>
                <div class="story-image" v-bind:class="orderImageElement">
                    <img :src="getImagePath(image)" :alt="header" />
                    <div v-if="image2 !== undefined">
                        <img class="secondaryImage" :src="getImagePath(image2)" :alt="header" />
                    </div>
                </div>
            </div>
        </div> 
    </section>
</template>

<script>
export default {
    name: "story",
    props: {
        theme: String,
        header: String,
        anchorId: String,
        image: String,
        image2: String,
        orderBy: String,
        readMore: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            showAll: false
        }
    },
    methods: {
        getImagePath(image) {
            console.log(this)
            var cdn = this.$store.getters['CONTENTDATA/CDN'];
            return cdn + image;
        },
        toggleShowAll() {
            this.showAll = !this.showAll
        }
    },
    computed:{
        orderTextElement() {
            return this.orderBy === "text"? "order-first" : "order-last";
        },
         orderImageElement() {
            return this.orderBy === "image"? "order-first" : "order-last";
        }
    }
}
</script>

<style lang="postcss" scoped>

@media only screen and (min-width: 768px) {
    .story::before {
        display: block;
        content: "";
        height: 50px;
        visibility: hidden;
        pointer-events: none;
    }
}


.story-header {  text-transform: uppercase; font-family: Didot; font-size: 1.1em; margin-top: 0; line-height: 25px; }
h4 {
   font-size: 1.6em;
   line-height: 25px;
   font-weight: normal;
   font-family: Didot-Italic;	
}
.story { width: 100%; height: 100%; margin: auto;  }
.story-content { display: flex; align-items: center; }
.story-text { width: 55%; padding-right: 10%; padding-top: 3%; }
.info {
    text-align: left; 
    padding:0% 5% 0% 20%;  
    height:100%;
}

.story-image { width: 40%; padding-top: 3%; }

.dark { background-color:gray; color: white;}
.light { background:white; color: black;}
.order-first { order: 1; }
.order-last {  order: 2; }
.story-image img {  width:100%; }
.secondaryImage {margin-top: 10%;}

@media only screen and (max-width: 768px) {
    .story {padding-top: 0; padding-bottom: 10%;} 
    .story-content { width: 100%; flex-direction: column; flex-wrap: wrap; }
    .story-image {width: 100%; order: 1 !important; padding-top: 0%; } 
    .story-text {order: 2 !important; width: 100%; padding: 0; }
    .info {padding: 5%;}
    .info h4 { line-height: 1.2em; }
    .secondaryImage { display: none; } 
    .story-header {
        text-align: center;
    }
    .info h4 {
        font-size: 1.4em;
        text-align: center;
    }
}

.slot p {
    display: none;
}

.slot p:first-of-type {
    display: block;
    overflow: hidden;
    height: 3em;
}

</style>